(() => {
  const root = document.querySelector('[data-cdc-pro-direct]');
  if (!root) return;

  const products = {
    ib320: { name: 'T-shirt homme IB320', unit: 'pièces' },
    k476: { name: 'Sweat homme K476', unit: 'pièces' },
    'dtf-a4': { name: 'Film DTF A4', unit: 'films' }
  };
  const formatMoney = amount => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(amount);
  const choices = [...root.querySelectorAll('[data-pro-product]')];
  const sizes = [...root.querySelectorAll('[data-pro-size]')];
  const cart = [];
  let selected = 'ib320';

  function configuration() {
    const button = choices.find(choice => choice.dataset.proProduct === selected);
    const price = Number(button.dataset.proPrice);
    const isFilm = selected === 'dtf-a4';
    const distribution = sizes.map(input => ({ size: input.dataset.proSize, quantity: Math.max(0, Number.parseInt(input.value, 10) || 0) })).filter(item => item.quantity > 0);
    const quantity = isFilm ? Math.max(0, Number.parseInt(root.querySelector('[data-pro-film-quantity]').value, 10) || 0) : distribution.reduce((sum, item) => sum + item.quantity, 0);
    const detail = isFilm ? 'Format A4' : `${root.querySelector('[data-pro-color]').value} · ${root.querySelector('[data-pro-placement]').value} · ${distribution.map(item => `${item.size} × ${item.quantity}`).join(', ') || 'aucune taille'}`;
    return { id: selected, name: products[selected].name, unit: products[selected].unit, quantity, price, detail };
  }

  function updateCurrent() {
    const item = configuration();
    root.querySelector('[data-pro-current-name]').textContent = item.name;
    root.querySelector('[data-pro-current-detail]').textContent = item.detail;
    root.querySelector('[data-pro-current-quantity]').textContent = `${item.quantity} ${item.unit}`;
    root.querySelector('[data-pro-current-total]').textContent = `${formatMoney(item.quantity * item.price)}*`;
    root.querySelector('[data-pro-error]').hidden = true;
  }

  function renderCart() {
    const target = root.querySelector('[data-pro-cart]');
    target.replaceChildren();
    if (!cart.length) {
      const empty = document.createElement('p');
      empty.textContent = 'Ajoutez une configuration pour composer une commande avec plusieurs produits.';
      target.append(empty);
    }
    cart.forEach((item, index) => {
      const line = document.createElement('div');
      line.className = 'directCartLine';
      const information = document.createElement('div');
      const name = document.createElement('strong');
      name.textContent = item.name;
      const detail = document.createElement('small');
      detail.textContent = `${item.detail} · ${item.quantity} ${item.unit}`;
      information.append(name, detail);
      const amount = document.createElement('strong');
      amount.textContent = formatMoney(item.quantity * item.price);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.proRemove = String(index);
      remove.setAttribute('aria-label', `Retirer ${item.name} du panier de démonstration`);
      remove.textContent = '×';
      line.append(information, amount, remove);
      target.append(line);
    });
    root.querySelector('[data-pro-cart-total]').textContent = `${formatMoney(cart.reduce((sum, item) => sum + item.quantity * item.price, 0))}*`;
  }

  choices.forEach(choice => choice.addEventListener('click', () => {
    selected = choice.dataset.proProduct;
    choices.forEach(button => {
      const active = button === choice;
      button.classList.toggle('isActive', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const isFilm = selected === 'dtf-a4';
    root.querySelector('[data-pro-textile]').hidden = isFilm;
    root.querySelector('[data-pro-transfer]').hidden = !isFilm;
    updateCurrent();
  }));

  root.addEventListener('input', event => {
    if (event.target.matches('[data-pro-size], [data-pro-film-quantity], [data-pro-color], [data-pro-placement]')) updateCurrent();
    if (event.target.matches('[data-pro-file]')) {
      const file = event.target.files?.[0];
      root.querySelector('[data-pro-file-name]').textContent = file ? file.name : 'Aucun fichier sélectionné';
    }
  });
  root.addEventListener('change', event => {
    if (event.target.matches('[data-pro-color], [data-pro-placement]')) updateCurrent();
  });
  root.querySelector('[data-pro-add]').addEventListener('click', () => {
    const item = configuration();
    if (item.quantity < 1 || item.quantity > 999) {
      const error = root.querySelector('[data-pro-error]');
      error.textContent = 'Indiquez une quantité comprise entre 1 et 999 pour ajouter cette configuration.';
      error.hidden = false;
      return;
    }
    cart.push(item);
    renderCart();
    root.querySelector('[data-pro-error]').hidden = true;
  });
  root.querySelector('[data-pro-cart]').addEventListener('click', event => {
    const remove = event.target.closest('[data-pro-remove]');
    if (!remove) return;
    cart.splice(Number(remove.dataset.proRemove), 1);
    renderCart();
  });
  updateCurrent();
  renderCart();
})();
